export const ITEM_VARIANT = {
  LIST: 'list',
  QUICK_VIEW: 'qv',
  CARD: 'card',
}

export const LABEL_SIZE = '1rem'